<template>
<div>
  <div>
    <el-button size="mini" @click="download">下载线路架构图</el-button>
    总数：{{excel_list_length}}&nbsp;&nbsp;线路架构：{{tree_length}}&nbsp;&nbsp;差异数：
    <el-link type="primary" @click="dialogVisible=true">{{excel_list_length-tree_length}}</el-link>
  </div>

  <div id="mountNode"></div>
  <el-dialog title="未在线路架构图上的仪表" :visible.sync="dialogVisible" width="80vw">
    <el-table v-if="dialogVisible" :data="diff_data" style="width: 100%;" height="500">
      <el-table-column label="编号" prop="number" width="150"></el-table-column>
      <el-table-column label="能耗类型" prop="energy" width="100"></el-table-column>
      <el-table-column label="名称" prop="name" width="250"></el-table-column>
      <el-table-column label="所属房产" prop="house_name"></el-table-column>
      <el-table-column label="上级编号" prop="parent_number" width="150"></el-table-column>
      <el-table-column label="上级状态" prop="is_parent_number" width="80">
        <template slot-scope="scope">
          <el-link :type="scope.row.is_parent_number?'success':'danger'">{{scope.row.is_parent_number?'存在':'不存在'}}</el-link>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</div>
</template>

<script>
import G6 from "@antv/g6";
import MeterNumberDiagramHelp from "./common/MeterNumberDiagramHelp";
const COLLAPSE_ICON = function COLLAPSE_ICON(x, y, r) {
  return [
    ['M', x - r, y - r],
    ['a', r, r, 0, 1, 0, r * 2, 0],
    ['a', r, r, 0, 1, 0, -r * 2, 0],
    ['M', x + 2 - r, y - r],
    ['L', x + r - 2, y - r],
  ];
};
const EXPAND_ICON = function EXPAND_ICON(x, y, r) {
  return [
    ['M', x - r, y - r],
    ['a', r, r, 0, 1, 0, r * 2, 0],
    ['a', r, r, 0, 1, 0, -r * 2, 0],
    ['M', x + 2 - r, y - r],
    ['L', x + r - 2, y - r],
    ['M', x, y - 2 * r + 2],
    ['L', x, y - 2],
  ];
};



export default {
  name: "MeterNumberDiagram",
  props:{
    excel_list:{
      type:Array,
      default(){
        return [];
      }
    },
    width: {
      type:Number,
      default() {
        return (window.innerWidth*0.95-40);
      }
    },
    height: {
      type:Number,
      default(){
        return (window.innerHeight*0.8 - 120);
      }
    },
  },
  data(){
    return {
      defaultConfig:{
        width: this.width,
        height: this.height,
        modes: {
          default: ['zoom-canvas', 'drag-canvas']
        },
        fitView: true, // 开启画布自适应。开启后图自动适配画布大小
        animate: true,
        // 节点样式
        defaultNode: {
          type: 'flow-rect', // flow-rect我们自定义的样式名称，告诉画板要引用哪个模块
          style: {
            fill: '#0095FF' // 默认的模板填充色
          },
          // 默认的模板的文字的填充色
          labelCfg: {
            style: {
              fill: '#fff',
              fontSize: 20,
              fontWeight: 800
            }
          }
        },
        // 线的样式
        defaultEdge: {
          type: 'polyline',
          size: 3, // 粗细
          style: {
            stroke: '#CED4D9'
          }
        },
        // 布局
        layout: {
          type: 'compactBox', // 布局类型
          direction: 'TB', // 展开的方向
          // 与子节点的相差的高度
          getHeight: () => {
            return 150
          },
          // 与子节点的相差的宽度
          getWidth: () => {
            return 200
          }
        },
        maxZoom: 1 // 展开时的放缩比例
      },
      meter_line:{
        label:'项目线路',
        children:[],
      },
      dialogVisible:false,
      excel_value:"",
      treeGraph:null,
      tree_length:0,
      tree_data:[],
      excel_list_length:0,
      diff_data:[],
    }
  },
  created() {

  },
  mounted() {
    this.initData()
  },
  methods:{
    initData(){
      const that=this;
      that.excel_list_length=that.excel_list.length;
      let meter_line=MeterNumberDiagramHelp.getTreeAll('',that.excel_list);
      that.meter_line.children=ERP.reJson(meter_line);
      that.tree_data=MeterNumberDiagramHelp.getTreeData(that.meter_line.children);
      that.tree_length=that.tree_data.length;
      that.diff_data=MeterNumberDiagramHelp.getDiffData(that.excel_list,that.tree_data);
      setTimeout(function () {
        that.initGraph()
      },2000)
    },
    initGraph(){
      const that=this;
      const data = {
        label: this.meter_line.label,
        type: 'rect',
        size: [300, 40],
        anchorPoints: [
          [0.5, 0],
          [0.5, 1]
        ],
        getHeight: () => {
          return 10
        },
        getWidth: () => {
          return 150
        },
        children: this.meter_line.children
      };
      const colors = {
        A: '#D6F3DA',
        B: '#FDEBD3',
        C: '#D7D7D7'
      };
      // 默认配置
      const defaultConfig = this.defaultConfig;
      // 自定义节点和边
      const registerFn = () => {
        /**
         * 自定义节点
         */
        G6.registerNode(
          'flow-rect', // 自定义的节点名称，在上面进行引用
          {
            shapeType: 'flow-rect',
            // 这里涉及到模板的生命周期函数，官网上面有详细的讲解
            draw(cfg, group) {
              const {
                colorIndex, organizationName, postName, meterNumber, meterCountLabel, meterCountValue,
                meterNextCountLabel, meterNextCountLabelValue, successionReadiness, successionReadinessValue
              } = cfg
              // 自定义模板
              const rectConfig = {
                width: 214,
                height: 147,
                fill: '#fff',
                shadowOffsetX: 0, // 模板阴影的X轴偏移量
                shadowOffsetY: 0, // 模板阴影的Y轴偏移量
                shadowColor: '#999',
                shadowBlur: 10
              }
              // 规定边界，便于定位
              const nodeOrigin = {
                x: -rectConfig.width / 2,
                y: -rectConfig.height / 2
              }
              // 规定文字位置，对齐方式
              const textConfig = {
                textAlign: 'left',
                textBaseline: 'bottom'
              }
              // 初始化模板
              const rect = group.addShape('rect', {
                attrs: {
                  x: nodeOrigin.x,
                  y: nodeOrigin.y,
                  ...rectConfig
                }
              })

              let width=214;
              let height=50;

              // 背景板
              group.addShape('rect', {
                attrs: {
                  x: nodeOrigin.x, // x轴位置
                  y: nodeOrigin.y, // y轴位置
                  width: width,
                  height: height,
                  // radius: [0, 0, rectConfig.radius, rectConfig.radius],//锐角化
                  fill: "#ffffff" // 填充色
                }
              })

              group.addShape('rect', {
                attrs: {
                  x: 4 + nodeOrigin.x,
                  y: 30 + nodeOrigin.y,
                  width: 204,
                  height: 1,
                  fill: '#333',
                  opacity: 0.35
                }
              })

              // 线
              group.addShape('text', {
                attrs: {
                  ...textConfig,
                  x: 9 + nodeOrigin.x,
                  y: 25 + nodeOrigin.y,
                  text: cfg.name,
                  height: 18,
                  fontSize: 16,
                  fontWeight: 800,
                  fill: '#333',
                  opacity: 1
                }
              })

              // 编号
              group.addShape('text', {
                attrs: {
                  ...textConfig,
                  x: 9 + nodeOrigin.x,
                  y: 60 + nodeOrigin.y,
                  text: "编号",
                  fontSize: 16,
                  fill: '#555',
                  opacity: 1
                }
              })
              group.addShape('text', {
                attrs: {
                  ...textConfig,
                  x: -(130 + nodeOrigin.x),
                  y: 60 + nodeOrigin.y,
                  text: cfg.number,
                  fontSize: 16,
                  fontWeight: 800,
                  fill: '#555',
                  opacity: 1
                }
              })

              // 能耗类型
              group.addShape('text', {
                attrs: {
                  ...textConfig,
                  x: 9 + nodeOrigin.x,
                  y: 95 + nodeOrigin.y,
                  text: "能耗类型",
                  fontSize: 16,
                  fill: '#555',
                  opacity: 1
                }
              })
              group.addShape('text', {
                attrs: {
                  ...textConfig,
                  x: -(130 + nodeOrigin.x),
                  y: 95 + nodeOrigin.y,
                  text: cfg.energy,
                  fontSize: 16,
                  fontWeight: 800,
                  fill: '#555',
                  opacity: 1
                }
              })

              // 下级数量
              group.addShape('text', {
                attrs: {
                  ...textConfig,
                  x: 9 + nodeOrigin.x,
                  y: 130 + nodeOrigin.y,
                  text: "下级数量",
                  fontSize: 16,
                  fill: '#555',
                  opacity: 1
                }
              })
              group.addShape('text', {
                attrs: {
                  ...textConfig,
                  x: -(130 + nodeOrigin.x),
                  y: 130 + nodeOrigin.y,
                  text: cfg.count,
                  fontSize: 16,
                  fontWeight: 800,
                  fill: '#555',
                  opacity: 1
                }
              })

              // 跳转
              // group.addShape('image', {
              //   attrs: {
              //     x: -nodeOrigin.x - 36,
              //     y: 12 + nodeOrigin.y,
              //     img: require('@/assets/logo.png'),
              //     width: 26,
              //     height: 26,
              //     cursor: 'pointer'
              //   },
              //   name: 'deleteItem'
              // })



              // 如果不需要动态增加或删除元素，则不需要 add 这两个 marker
              // group.addShape('marker', {
              //   attrs: {
              //     x: -width/2+20,
              //     y: height+height/2-20,
              //     r: 10,
              //     stroke: '#73d13d',
              //     cursor: 'pointer',
              //     symbol: EXPAND_ICON,
              //   },
              //   // must be assigned in G6 3.3 and later versions. it can be any string you want, but should be unique in a custom item type
              //   name: 'add-item',
              // });
              //
              // group.addShape('marker', {
              //   attrs: {
              //     x: width/2-20,
              //     y: height+height/2-20,
              //     r: 10,
              //     stroke: '#ff4d4f',
              //     cursor: 'pointer',
              //     symbol: COLLAPSE_ICON,
              //   },
              //   // must be assigned in G6 3.3 and later versions. it can be any string you want, but should be unique in a custom item type
              //   name: 'remove-item',
              // });


              return rect
            },
            // 定义锚点，G6会自动连接两个节点的最近的锚点
            getAnchorPoints() {
              return [
                // [0, 0.5], // 左侧中间
                // [1, 0.5], // 右侧中间
                [0.5, 0], // 上侧中间
                [0.5, 1] // 下侧中间
              ]
            }
          },
          'rect'
        )
      };
      registerFn();
      // 画布主体
      that.treeGraph = new G6.TreeGraph({
        container: 'mountNode', // 制定画布的容器
        ...defaultConfig
      })

      that.treeGraph.on('node:click', (evt) => {
        const { item, target } = evt;
        const targetType = target.get('type');
        const name = target.get('name');

        // 增加元素
        if (targetType === 'marker') {
          const model = item.getModel();
          if (name === 'add-item') {
            if (!model.children) {
              model.children = [];
            }

            const id = `n-${Math.random()}`;
            model.children.push({
              id,
              meterNumber: '10kV朱鼎甲线',
              meterCountLabel: '仪表数量：',
              meterCountValue: 0,
              meterNextCountLabel: '下级仪表数量：',
              meterNextCountLabelValue: 0,
            });
            that.treeGraph.updateChild(model, model.id);
          } else if (name === 'remove-item') {
            that.treeGraph.removeChild(model.id);
          }
        }
      });

      // deleteItem: 对于需要单独操作的元素，请在定义数据的时候定义nama值，这样才可以定位到指定元素
      that.treeGraph.on('deleteItem:click', (ev) => {
        const shape = ev.target
        const node = ev.item
        console.log(shape)
        console.log(node)
      })

      that.treeGraph.data(data) // 加载数据
      that.treeGraph.render() // 渲染

      const container = document.getElementById('container');
      if (typeof window !== 'undefined')
        window.onresize = () => {
          if (!that.treeGraph || that.treeGraph.get('destroyed')) return;
          if (!container || !container.scrollWidth || !container.scrollHeight) return;
          that.treeGraph.changeSize(container.scrollWidth, container.scrollHeight);
        };


    },
    reData(parent_number="",excel_list=""){
      const that=this;
      that.excel_list_length=excel_list.length;
      let meter_line=MeterNumberDiagramHelp.getTreeAll(parent_number,excel_list);
      that.meter_line.children=ERP.reJson(meter_line);
      that.tree_data=MeterNumberDiagramHelp.getTreeData(that.meter_line.children);
      that.tree_length=that.tree_data.length;
      that.diff_data=MeterNumberDiagramHelp.getDiffData(that.excel_list,that.tree_data);
      const data = {
        label: this.meter_line.label,
        type: 'rect',
        size: [300, 40],
        anchorPoints: [
          [0.5, 0],
          [0.5, 1]
        ],
        getHeight: () => {
          return 10
        },
        getWidth: () => {
          return 150
        },
        children: this.meter_line.children
      };
      that.treeGraph.data(data) // 加载数据
      that.treeGraph.render() // 渲染
    },
    download(){
      const that=this;
      let time=(new Date()).getTime().toString()
      that.treeGraph.downloadFullImage('仪表架构图_'+time, 'image/png', {
        backgroundColor: '#FFFFFF',
        padding: [30, 15, 15, 15],
      });
    }
  },
  watch:{
    excel_list:{
      immediate:true,
      deep:true,
      handler(){
        if(this.treeGraph){
          this.reData("",this.excel_list);
        }
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter/components/MeterNumberDiagram.vue